import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SuggestionContainer = styled(Grid)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const Suggestion = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected: boolean }>(
  {
    borderRadius: "5px",
    padding: "5px",
    cursor: "pointer",
  },
  ({ isSelected, theme }) => ({
    ...(isSelected && {
      border: `0.5px solid ${theme.palette.primary.main}`,
    }),
  })
);
